<script>
  export default {
    props: {
      stepNumber: {
        type: Number,
        default: 0,
      },
      stepName: {
        type: String,
        default: '',
      },
    },
    methods: {
      isStep(step) {
        return step === this.stepNumber
      },
    },
  }
</script>

<template>
  <div>
    <slot v-if="isStep(stepNumber)" :name="`${stepName}`"></slot>
  </div>
</template>
